import styled from 'styled-components'
import { ChangeOwnerSearchResult } from './ChangeOwnerSearchResult'

export const ChangeOwnerSearchResultUI = styled(ChangeOwnerSearchResult)``
